<template>
    <div :class="$store.state.user.appEnable ? 'viewBoxGlobalSpecial' : 'viewBoxGlobal'" ref="fatherScroll">
        <div class="box">
            <template v-if="categoryList!=null&&gameList!=null">
                <Notice @changeNoticeVisible="changeNoticeVisible"></Notice>
                <Banner></Banner>
                <!--导航-->
                <ClassList ref="classListCom">
                    <div class="class-list-container">
                        <div class="previous-list" @click="scrollLeft">
                            <div class="list-button">
                                <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="200" height="200"><path d="M765.952 124.928l0 81.92 0 129.024 0 156.672 0 159.744q0 76.8 0.512 141.312t0.512 100.352q0 24.576-11.776 40.96t-29.696 22.016-39.424 0-39.936-24.064q-37.888-38.912-81.92-81.408t-90.624-85.504-94.208-86.016-91.648-82.944q-19.456-17.408-29.184-43.008t-8.704-53.248 11.776-54.272 32.256-45.056q39.936-34.816 79.36-70.144t80.896-72.704 87.04-78.336 96.768-87.04q22.528-20.48 45.568-27.136t41.472-2.048 29.696 20.48 11.264 40.448z" fill="#ffffff"></path></svg>
                            </div>
                        </div>
                        <div class="class-list">
                            <ClassItem v-for="(item,index) in categoryFilterList"
                                :style="index == 0 ? 'transform-origin: left center;' : index == categoryFilterList.length -1 ? 'transform-origin: right center;' : ''"
                                :key="index"
                                :item="item"
                                :index="index"
                                :changeClass="changeClass"
                                :active="categoryIndex===index"
                                :categoryName="item.categoryName">
                            </ClassItem>
                        </div>
                        <div class="next-list" @click="scrollRight">
                            <div class="list-button">
                                <svg style="transform:rotate(180deg)" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="200" height="200"><path d="M765.952 124.928l0 81.92 0 129.024 0 156.672 0 159.744q0 76.8 0.512 141.312t0.512 100.352q0 24.576-11.776 40.96t-29.696 22.016-39.424 0-39.936-24.064q-37.888-38.912-81.92-81.408t-90.624-85.504-94.208-86.016-91.648-82.944q-19.456-17.408-29.184-43.008t-8.704-53.248 11.776-54.272 32.256-45.056q39.936-34.816 79.36-70.144t80.896-72.704 87.04-78.336 96.768-87.04q22.528-20.48 45.568-27.136t41.472-2.048 29.696 20.48 11.264 40.448z" fill="#ffffff"></path></svg>
                            </div>
                        </div>
                    </div>
                </ClassList>
                <template v-if="categoryList.length > 0 && categoryIndex===0">
                    <!--点击过的游戏-->
                    <div class="game-box" v-if="recent.recentGameRecordEnabled">
                        <div class="game-title">
                            <div class="game-title-left">
                                <img :src="recent.recentGameRecordIcon"/>
                                <span style="margin-left:1rem">{{ recent.recentGameRecordLabel }}</span>
                            </div>
                        </div>
                        <div class="recent-list">
                            <RecentItem v-for="(item,index) in historyList.map(gameId => gameList.find(game => game.gameId === gameId)).filter((item, index, self) => index === self.findIndex(el => el.gameId === item.gameId))" :key="index" :item="item" :click="toGame"></RecentItem>
                        </div>
                    </div>
                    <!--目录相关-->
                    <div class="game-box" :style="index == 0 ? 'margin-top:2rem;' : ''" v-for="(item,index) in categoryList.filter(a=>a.parentId===0)[categoryIndex].children" :key="index">
                        <!--目录图片及viewall-->
                        <div class="game-title">
                            <div class="game-title-left">
                                <img :src="item.fullCategoryImg"/>
                                <span v-text="item.categoryName"></span>
                            </div>
                            <div class="game-title-right" @click="moreClick(item)">
                                {{ $t("ViewAll") }}
                            </div>
                        </div>
                        <div class="game-list">
                            <PaginationM :folderSource="getSubAll(item)" :gameSource="gameList.filter(g => g.categoryId === item.categoryId)">
                            </PaginationM>
                        </div>
                    </div>
                    <div style="height:20rem;" v-if="categoryList.length <= 0">
                    </div>
                </template>
                <template v-if="categoryList.length > 0 && categoryIndex == 2">
                    <div class="game-box">
                        <div class="searchBox">
                            <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6963" width="200" height="200">
                                <path d="M215.51289 370.94645c2.566452 1.534959 5.383614 2.25332 8.16803 2.25332 5.476735 0 10.796904-2.800789 13.802354-7.839549 45.552475-76.69373 129.193431-124.343983 218.281445-124.343983 8.856715 0 16.023952-7.166213 16.023952-16.023952s-7.167237-16.023952-16.023952-16.023952c-100.338243 0-194.541765 53.658084-245.838058 140.022057C205.404672 356.596627 207.907679 366.440833 215.51289 370.94645z" fill="#272636"></path>
                                <path d="M196.751594 417.501766c-8.607028-1.987261-17.229406 3.332908-19.24839 11.955286-4.78805 20.451798-7.495718 33.127492-7.495718 55.879682 0 8.856715 7.182586 16.023952 16.023952 16.023952 8.857738 0 16.024975-7.167237 16.024975-16.023952 0-19.309788 2.159176-29.387307 6.650467-48.588625C210.724841 428.125731 205.372949 419.519726 196.751594 417.501766z" fill="#272636"></path>
                                <path d="M947.204451 876.167047 784.053628 713.013153c-0.441045-0.442068-0.893346-0.86367-1.351787-1.272993 41.450041-62.197574 65.652256-136.821155 65.652256-217.013569 0-216.480426-176.10895-392.589376-392.588353-392.589376-216.4661 0-392.589376 176.10895-392.589376 392.589376 0 216.47224 176.123276 392.58119 392.589376 392.58119 78.758762 0 152.117536-23.378453 213.647915-63.470567l-46.695508-46.694485c-49.01125 29.074176-105.971543 46.069245-166.952406 46.069245-181.131337 0-328.493569-147.343813-328.493569-328.48436 0-181.131337 147.361209-328.493569 328.493569-328.493569 181.130314 0 328.493569 147.362232 328.493569 328.493569 0 85.36932-33.002648 162.956396-86.567611 221.433228l36.58422 36.585243c1.251503 1.983167 2.732228 3.860934 4.459568 5.588275l163.15287 163.151847c6.259564 6.259564 14.459317 9.389858 22.659069 9.389858s16.415878-3.130294 22.659069-9.389858C959.724603 908.980383 959.724603 888.684128 947.204451 876.167047z" fill="#272636"></path>
                            </svg>
                            <input v-model="searchKey" placeholder="Search"/>
                        </div>
                        
                        <div class="game-list">
                            <PaginationM :folderSource="[]" :gameSource="setGameList.filter(item => (searchKey == '' || toLowerCase(item.gameName).indexOf(toLowerCase(searchKey)) != -1)).filter(item => favoriteList.indexOf(item.gameId) != -1)">
                            </PaginationM>
                        </div>
                    </div>
                    <div style="height:20rem;" v-if="favoriteList.length <= 0">
                    </div>
                </template>
                <template v-if="(categoryList.length > 0 && categoryIndex > 0) && categoryIndex != 2">
                    <div class="game-box">
                        <div class="searchBox">
                            <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6963" width="200" height="200">
                                <path d="M215.51289 370.94645c2.566452 1.534959 5.383614 2.25332 8.16803 2.25332 5.476735 0 10.796904-2.800789 13.802354-7.839549 45.552475-76.69373 129.193431-124.343983 218.281445-124.343983 8.856715 0 16.023952-7.166213 16.023952-16.023952s-7.167237-16.023952-16.023952-16.023952c-100.338243 0-194.541765 53.658084-245.838058 140.022057C205.404672 356.596627 207.907679 366.440833 215.51289 370.94645z" fill="#272636"></path>
                                <path d="M196.751594 417.501766c-8.607028-1.987261-17.229406 3.332908-19.24839 11.955286-4.78805 20.451798-7.495718 33.127492-7.495718 55.879682 0 8.856715 7.182586 16.023952 16.023952 16.023952 8.857738 0 16.024975-7.167237 16.024975-16.023952 0-19.309788 2.159176-29.387307 6.650467-48.588625C210.724841 428.125731 205.372949 419.519726 196.751594 417.501766z" fill="#272636"></path>
                                <path d="M947.204451 876.167047 784.053628 713.013153c-0.441045-0.442068-0.893346-0.86367-1.351787-1.272993 41.450041-62.197574 65.652256-136.821155 65.652256-217.013569 0-216.480426-176.10895-392.589376-392.588353-392.589376-216.4661 0-392.589376 176.10895-392.589376 392.589376 0 216.47224 176.123276 392.58119 392.589376 392.58119 78.758762 0 152.117536-23.378453 213.647915-63.470567l-46.695508-46.694485c-49.01125 29.074176-105.971543 46.069245-166.952406 46.069245-181.131337 0-328.493569-147.343813-328.493569-328.48436 0-181.131337 147.361209-328.493569 328.493569-328.493569 181.130314 0 328.493569 147.362232 328.493569 328.493569 0 85.36932-33.002648 162.956396-86.567611 221.433228l36.58422 36.585243c1.251503 1.983167 2.732228 3.860934 4.459568 5.588275l163.15287 163.151847c6.259564 6.259564 14.459317 9.389858 22.659069 9.389858s16.415878-3.130294 22.659069-9.389858C959.724603 908.980383 959.724603 888.684128 947.204451 876.167047z" fill="#272636"></path>
                            </svg>
                            <input v-model="searchKey" placeholder="Search"/>
                        </div>
                        <div class="game-box" :style="index == 0 ? 'margin-top:0;' : ''" v-for="(item,index) in categoryList.filter(a=>a.parentId===0)[categoryIndex].children" :key="index">
                            <template v-if="gameList.filter(g => g.categoryId === item.categoryId).filter(item2 => (searchKey == '' || toLowerCase(item2.gameName).indexOf(toLowerCase(searchKey)) != -1)).length != 0 || getSubAll(item).filter(item2 => (searchKey == '' || toLowerCase(item2.categoryName).indexOf(toLowerCase(searchKey)) != -1)).length != 0">
                                <!--目录图片及viewall-->
                                <div class="game-title">
                                    <div class="game-title-left">
                                        <img :src="item.fullCategoryImg"/>
                                        <span v-text="item.categoryName"></span>
                                    </div>
                                    <div class="game-title-right" @click="moreClick(item)">
                                        {{ $t("ViewAll") }}
                                    </div>
                                </div>
                                <div class="game-list">
                                    <PaginationM :folderSource="getSubAll(item).filter(item2 => (searchKey == '' || toLowerCase(item2.categoryName).indexOf(toLowerCase(searchKey)) != -1))" :gameSource="gameList.filter(g => g.categoryId === item.categoryId).filter(item2 => (searchKey == '' || toLowerCase(item2.gameName).indexOf(toLowerCase(searchKey)) != -1))">
                                    </PaginationM>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div style="height:20rem;" v-if="categoryList.length <= 0">
                    </div>
                </template>
            </template>
        </div>

        <!--<div class="cashwheelPopup" @click="toCashWheel">
            <img :src="stationimglist.length != 0 && stationimglist.filter(item => item.imgType == 6)[0]?.fullImgUrl" />
        </div>-->
        <template></template>

        <AdBox :right="2" :bottom="10 * (index + 1)" v-for="(type,index) in ['6','7','8'].map(type => this.stationimglist.filter(item => item.imgType == type)).filter(list => list.length > 0)">
            <SwiperImg :source="type" :id="index">
            </SwiperImg>
        </AdBox>

        <div class="addToScreen" @click="addToHomeScreen" v-if="$store.state.user.appTipEnable">
            <div class="addToScreenPover">
                <span>16</span>
                <img :src="BlackCoin"/>
            </div>
            {{ $t("AddToHomeScreen") }}
        </div>

        <Footer></Footer>

        <Modal :visible.sync="appdownloadVisible" :padding="false" :gradient="false" :hasBg="false">
            <DownloadAPP :visible.sync="appdownloadVisible"></DownloadAPP>
        </Modal>
        <Modal :visible.sync="appdownloadingVisible" :padding="false" :gradient="false" :hasBg="false">
            <InstallAPPLoading :visible.sync="appdownloadingVisible"></InstallAPPLoading>
        </Modal>

        <!--余额不足，请充值弹窗-->
        <Modal :visible.sync="confirmVisible" :gradient="true">
            <span class="confirmDes">{{ $t("YouNeedRecharge") }}</span>
            <div class="confirmOption">
                <div class="cancelButton" @click="closeConfirm">
                    {{ $t("Cancel") }}
                </div>
                <div class="confirmButton" @click="queryConfirm">
                    {{ $t("OK") }}
                </div>
            </div>
        </Modal>

        <!--App保存桌面-->
        <Drawer :visible.sync="addVisible">
            <div style="display:flex;flex-direction: column;align-items: center;height:fit-content">
                <div style="display:flex;justify-content: center;">
                    <span style="white-space:nowrap;color:#546276;font-size:1.8rem;font-weight:bold;">Click on the toolbar below</span>
                    <svg style="height:2rem;width:2rem;margin-left:2rem" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="200" height="200">
                        <path d="M924 1024H100A100 100 0 0 1 0 924V638a40 40 0 0 1 80 0v286a20 20 0 0 0 20 20h824a20 20 0 0 0 20-20V638a40 40 0 0 1 80 0v286a100 100 0 0 1-100 100zM784 352a40 40 0 0 1-28-12L512 97 268 340a40 40 0 0 1-57-57L484 12a40 40 0 0 1 57 0l271 272a40 40 0 0 1-28 68z" fill="#ffffff"></path>
                        <path d="M512 788a40 40 0 0 1-40-40V57a40 40 0 0 1 80 0v691a40 40 0 0 1-40 40z" fill="#ffffff"></path>
                    </svg>
                </div>
                <div style="display:flex;justify-content: center;margin-top:1rem">
                    <span style="white-space:nowrap;color:#546276;font-size:1.8rem;font-weight:bold;">and select</span>
                    <svg style="height:2rem;width:2rem;margin-left:1rem;margin-right:1rem;" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="200" height="200">
                        <path d="M832 1024H192c-106.048 0-192-86.016-192-192V192a192 192 0 0 1 192-192h640a192 192 0 0 1 192 192v640c0 105.984-85.952 192-192 192z m64-832a64 64 0 0 0-64-64H192a64 64 0 0 0-64 64v640c0 35.392 28.608 64 64 64h640c35.392 0 64-28.608 64-64V192z m-192 384h-128v128c0 35.392-28.608 64-64 64s-64-28.608-64-64v-128h-128a64 64 0 1 1 0-128h128v-128a64 64 0 1 1 128 0v128h128a64 64 0 1 1 0 128z" fill="#ffffff"></path>
                    </svg>
                    <span style="white-space:nowrap;color:#546276;font-size:1.8rem;font-weight:bold;">"Add to Home Screen"</span>
                </div>
                <img :src="AddToScreen" style="margin-top:1rem;width:90%;"/>
            </div>
        </Drawer>

        <Modal :visible.sync="noticeVisible" :beforeClose="closeNotice" :padding="false" :gradient="false" :hasBg="false">
            <div class="noticeOutBox">
                <div class="noticeBox" :style="'background-image:url(' + noticeModalInfo.bg + ')'">
                    <div class="noticeTitle">
                        <span v-text="noticeModalInfo.title"></span>
                    </div>
                    <div class="noticeText" v-html="noticeModalInfo.content">
                    </div>
                </div>
                <!-- <svg @click="closeNotice" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="200" height="200">
                    <path d="M548.992 503.744L885.44 167.328a31.968 31.968 0 1 0-45.248-45.248L503.744 458.496 167.328 122.08a31.968 31.968 0 1 0-45.248 45.248l336.416 336.416L122.08 840.16a31.968 31.968 0 1 0 45.248 45.248l336.416-336.416L840.16 885.44a31.968 31.968 0 1 0 45.248-45.248L548.992 503.744z" fill="#5e6f8f"></path>
                </svg> -->
                <!-- <svg @click="closeNotice" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="200" height="200">
                    <path d="M512 1024C229.376 1024 0 794.624 0 512S229.376 0 512 0s512 229.376 512 512-229.376 512-512 512z m0-975.36C257.024 48.64 48.64 257.024 48.64 512c0 254.976 207.872 463.36 463.36 463.36S975.36 767.488 975.36 512 766.976 48.64 512 48.64z" fill="#5e6f8f"></path>
                    <path d="M548.864 512l195.072-195.072c9.728-9.728 9.728-25.6 0-36.864l-1.536-1.536c-9.728-9.728-25.6-9.728-35.328 0L512 475.136 316.928 280.064c-9.728-9.728-25.6-9.728-35.328 0l-1.536 1.536c-9.728 9.728-9.728 25.6 0 36.864L475.136 512 280.064 707.072c-9.728 9.728-9.728 25.6 0 36.864l1.536 1.536c9.728 9.728 25.6 9.728 35.328 0L512 548.864l195.072 195.072c9.728 9.728 25.6 9.728 35.328 0l1.536-1.536c9.728-9.728 9.728-25.6 0-36.864L548.864 512z" fill="#5e6f8f"></path>
                </svg> -->
                <svg @click="closeNotice" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="200" height="200">
                    <path d="M512 870.4c-197.93 0-358.4-160.47-358.4-358.4S314.07 153.6 512 153.6 870.4 314.07 870.4 512 709.93 870.4 512 870.4z m0 89.6c247.424 0 448-200.576 448-448S759.424 64 512 64 64 264.576 64 512s200.576 448 448 448z"></path>
                    <path d="M686.23 686.23a44.8 44.8 0 0 1-63.36 0l-285.1-285.1a44.8 44.8 0 0 1 63.36-63.36l285.1 285.1a44.8 44.8 0 0 1 0 63.36z"></path>
                    <path d="M686.23 337.77a44.8 44.8 0 0 1 0 63.36l-285.1 285.1a44.8 44.8 0 0 1-63.36-63.36l285.1-285.1a44.8 44.8 0 0 1 63.36 0z"></path>
                </svg>
            </div>
        </Modal>

        <Modal :visible.sync="adverVisible" :beforeClose="closeAdv" :padding="false" :hasBg="false">
            <div class="adverBox">
                <div class="adver-container" style="position:relative;">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item) in adImgArr" :key="item.id" :dataRoute="item.routerUrl">
                            <img :src="item.fullImgUrl" alt=""  />
                        </div>
                    </div>
                    <div class="swiper-button-prev"></div>
                    <div class="swiper-button-next"></div>
                </div>
                <span class="closeButton">
                    <svg @click="closeAdv" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="200" height="200">
                        <path d="M512 870.4c-197.93 0-358.4-160.47-358.4-358.4S314.07 153.6 512 153.6 870.4 314.07 870.4 512 709.93 870.4 512 870.4z m0 89.6c247.424 0 448-200.576 448-448S759.424 64 512 64 64 264.576 64 512s200.576 448 448 448z"></path>
                        <path d="M686.23 686.23a44.8 44.8 0 0 1-63.36 0l-285.1-285.1a44.8 44.8 0 0 1 63.36-63.36l285.1 285.1a44.8 44.8 0 0 1 0 63.36z"></path>
                        <path d="M686.23 337.77a44.8 44.8 0 0 1 0 63.36l-285.1 285.1a44.8 44.8 0 0 1-63.36-63.36l285.1-285.1a44.8 44.8 0 0 1 63.36 0z"></path>
                    </svg>
                </span>
            </div>
        </Modal>

        <template v-if="cashVisible">
            <Modal :visible.sync="wheelVisible" :padding="false" :hasBg="false" :special="true">
                <SimpleWheel ref="simpleWheel" :visible.sync="wheelVisible" :activityId="cashwheelid" :rule="cashwheelrule" :startTime="cashStartTime" :endTime="cashEndTime"></SimpleWheel>
            </Modal>
        </template>
    </div>
</template>

<script>

import Footer from "@/components/Footer.vue"
import Modal from "@/components/Modal.vue"
import Drawer from "@/components/Drawer.vue"
import Search from "@/assets/img/search.png"
import BlackCoin from "@/assets/img/blackcoin.png";
import AddToScreen from "@/assets/img/addtoscreen.png"
import Banner from "@/components/Banner.vue";
import ClassItem from "@/components/ClassItem.vue";
import RecentItem from "@/components/RecentItem.vue";
import GameItem from "@/components/GameItem.vue";
import FolderItem from "@/components/FolderItem.vue";
import CategoryItem from "@/components/CategoryItem.vue";
import Notice from "@/components/Notice.vue";
import AdBox from "@/components/AdBox.vue";
import SimpleWheel from "@/components/SimpleWheel.vue";
import ClassList from "@/components/ClassList.vue";
import PaginationM from "@/components/Pagination.vue";
import Empty from "@/components/Empty.vue";
import SwiperImg from "@/components/SwiperImg.vue";
import DownloadAPP from "@/components/DownloadAPP.vue";
import InstallAPPLoading from "@/components/InstallAPPLoading.vue";

import { Lucky } from "@/api/cashwheel";
import { toLowerCase } from "@/utils/dateUtil.js";
import { getHashParam } from "@/utils/utils.js";
import { mapState } from 'vuex';

import Ad1 from "@/assets/img/ad01.png"
import Ad2 from "@/assets/img/ad02.png"
import NoticBg from "@/assets/img/appBg.png"
import EventBus from "@/main";

import Swiper, {Pagination, Navigation} from 'swiper';
Swiper.use([Pagination, Navigation])
import 'swiper/swiper-bundle.css';

export default {
    name: "Home",
    
    data() {
        return {
            toLowerCase,
            Ad1,
            Ad2,
            NoticBg,
            AddToScreen,
            BlackCoin,
            Banner,
            Search,

            wheelVisible:false,

            categoryIndex: 0,
            intervalId: null,
            confirmVisible: false,
            addVisible: false,

            //是否展开全部游戏-目录id
            showAllGames: [],

            noticeVisible: false,
            adverVisible: false,

            cashVisible:false,
            cashwheelid:0,
            cashwheelrule:"", // 转盘规则
            cashStartTime:"", // 转盘开始时间
            cashEndTime:"", // 转盘结束事件

            searchKey:"", // 搜索关键字

            classlistscroll:false,

            noticeModalInfo:{
                title:"",
                content:"",
                bg:""
            },

            stopScroll:false,

            noticeBoxVisible:false,
            appdownloadVisible:false,
            appdownloadingVisible:false,
            adSwiper:false, // 广告轮播图弹窗

            deferredPrompt: null,
        }
    },
    components: {
        Footer,
        Modal,
        Drawer,
        Banner,
        ClassItem,
        RecentItem,
        GameItem,
        CategoryItem,
        Notice,
        AdBox,
        SimpleWheel,
        FolderItem,
        ClassList,
        PaginationM,
        Empty,
        SwiperImg,
        DownloadAPP,
        InstallAPPLoading
    },
    computed: {
        ...mapState({
            recent: state => state.user.recent,
            favoriteList:state => state.user.favoriteList
        }),
        gameList(){
            return this.$store.state.user.game
        },
        categoryList(){
            return this.$store.state.user.category
        },
        stationimglist(){
            return this.$store.state.user.stationimglist
        },
        noticeImg(){
            let result = this.$store.state.user.stationimglist.filter(item => item.imgType == 3);
            return result;
        },
        adImgArr(){
            return this.$store.state.user.stationimglist.filter(item => item.imgType == 3);
        },
        categoryFilterList(){
            return this.categoryList.filter(a=>a.parentId===0);
        },
        historyList(){
            let history = this.$store.state.user.historyList
            history.sort((a, b) => b.time - a.time);
            return history.map(item => item.id);
        },
        setGameList() {
            // 通过 gameId 过滤重复项
            const uniqueGames = this.$store.state.user.game.filter((game, index, self) =>
                index === self.findIndex((g) => g.gameId === game.gameId)
            );
            return uniqueGames;
        }
    },
    methods: {
        toGame(item) {
            const game = item;
            //这里需要判断是否已经登录，如果没有登录跳转到登录页面
            if (!this.$store.state.user.token) {
                this.$router.push({path: "/login", query: {mode: "login"}});
                return;
            }
            //这里需要判断余额是否足够
            if (this.$store.state.user?.user?.balance < game.minBalanceEnter) {
                this.confirmVisible = true;
                return;
            }
            this.setHistory(game.gameId);
            const gameParams = {channel: game.channelBean, gameId: game.gameId, gameCode: game.gameCode, lang: ""};
            if(this.type == 'home'){
                this.$router.push({
                    path: '/other',
                    query: {data: JSON.stringify(gameParams), type: "game",intype:'home'}
                });
            }else{
                this.$router.push({
                    path: '/other',
                    query: {data: JSON.stringify(gameParams), type: "game",intype:'folder',folderid:this.categoryId,foldername:this.categoryName}
                });
            }
        },
        changeNoticeVisible(flag){
            this.noticeBoxVisible = flag;
        },
        initAdvInfo(){
            let noticeStore = this.$store.state.user.noticeAllList[0];
            if(noticeStore){
                this.noticeModalInfo = {
                    title:noticeStore.noticeTitle,
                    content:noticeStore.noticeContent,
                    bg:noticeStore.fullNoticeImg
                }
                this.noticeVisible = true;
            }else{ // 不显示广告弹窗
                this.noticeVisible = false;
                this.initAdv2Info();
            }
        },
        toRoute(url){
            if(url.indexOf('https') != -1){
                window.open(url, '_blank');
            }else{
                this.$router.push(url);
            }
        },
        initAdv2Info(){
            if(this.adImgArr.length > 0){
                this.adverVisible = true;
                this.$forceUpdate();
                this.$nextTick(() => {
                    this.adSwiper = new Swiper('.adver-container', {
                        loop: this.adImgArr.length > 1, // 是否循环播放
                        autoplay: this.adImgArr.length > 1 ? { disableOnInteraction:false,delay: 3000 } : false,
                        speed: 1000,
                        on: {
                            click: (swiper, event) => {
                                if(this.adSwiper.clickedSlide){
                                    this.toRoute(this.adSwiper.clickedSlide.attributes.dataRoute.value);
                                }
                            },
                        },
                        navigation: {
                            prevEl: '.swiper-button-prev', // 上一个按钮
                            nextEl: '.swiper-button-next'  // 下一个按钮
                        }
                    });
                })
            }
        },
        getSubAll(item) {
            // 递归函数，用于提取所有子节点
            function extractChildren(node) {
                let result = [];
                // 如果当前节点有 children，提取子节点
                if (node.children && node.children.length) {
                    // 将当前节点的 children 添加到结果数组
                    result = result.concat(node.children);
                    // 递归调用，提取当前 children 的 children
                    node.children.forEach(child => {
                        result = result.concat(extractChildren(child));
                    });
                }
                return result;
            }
            // 提取 item 的所有子节点（包括 item 本身的 children）
            return extractChildren(item);
        },
        toCashWheel(){
            this.wheelVisible = true;
        },  
        scrollLeft() {
            let container;
            if(this.classlistscroll){
                container = document.getElementsByClassName("class-list")[1]
            }else{
                container = document.getElementsByClassName("class-list")[0]
            }
            const scrollAmount = 200; // 滚动的像素数
            // 计算新的滚动位置
            const newScrollLeft = Math.max(container.scrollLeft - scrollAmount, 0);
            // 平滑滚动到新的位置
            container.scrollTo({
                left: newScrollLeft,
                behavior: 'smooth'
            });
        },
        scrollRight() {
            let container;
            if(this.classlistscroll){
                container = document.getElementsByClassName("class-list")[1]
            }else{
                container = document.getElementsByClassName("class-list")[0]
            }
            const scrollAmount = 200; // 滚动的像素数
            // 计算新的滚动位置
            const maxScrollLeft = container.scrollWidth - container.clientWidth;
            const newScrollLeft = Math.min(container.scrollLeft + scrollAmount, maxScrollLeft);
            // 平滑滚动到新的位置
            container.scrollTo({
                left: newScrollLeft,
                behavior: 'smooth'
            });
        },
        closeAdv() {
            this.adverVisible = false;
            localStorage.setItem("readPopover","1");
        },
        closeNotice() {
            this.noticeVisible = false;
            this.initAdv2Info();
        },
        queryConfirm() {
            this.$router.push("/deposit?mode=deposit")
        },
        closeConfirm() {
            this.confirmVisible = false;
        },
        checkScroll() {
            const scrollTop = this.$refs.fatherScroll.scrollTop;
            const targetScroll = parseFloat(getComputedStyle(document.documentElement).fontSize) * 34; // 计算 15rem 的像素值
            this.classlistscroll = scrollTop >= targetScroll; 
            this.$refs.classListCom.changeScrollTop(this.classlistscroll);
        },
        changeClass(index) {
            // 现在的想法就是在滚动之前将容器的可滚动的css取消掉之后再改变scrollTop然后再调回来
            this.$refs.fatherScroll.style.overflowY = "hidden";
            this.$nextTick(() => {
                this.categoryIndex = index;
                const scrollTop = this.$refs.fatherScroll.scrollTop;
                const fontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
                const limit = this.noticeBoxVisible ? 34 : 29;
                if (scrollTop > fontSize * limit) {
                    this.$refs.fatherScroll.scrollTop = fontSize * limit;
                }
                this.$nextTick(() => {
                    this.$refs.fatherScroll.style.overflowY = "scroll";
                    this.$forceUpdate();
                })
            })
        },
        addToHomeScreen() {
            if (this.deferredPrompt) {
                this.deferredPrompt.prompt();
                this.deferredPrompt.userChoice.then((choiceResult) => {
                    if (choiceResult.outcome === 'accepted') {
                        // 接受就显示一个加载条
                        this.appdownloadingVisible = true;
                    } else {
                        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
                        if (/android/i.test(userAgent)) { // 下载apk文件
                            this.appdownloadVisible = true;
                        } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
                            window.location.href = 'itms-apps://apps.apple.com/app/id1';
                        } else { // 下载apk文件
                            this.appdownloadVisible = true;
                        }
                    }
                    this.deferredPrompt = null;
                });
            } else { // 不支持
                // 判断是安卓还是苹果
                const userAgent = navigator.userAgent || navigator.vendor || window.opera;
                if (/android/i.test(userAgent)) { // 下载apk文件
                    this.appdownloadVisible = true;
                } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
                    window.location.href = 'itms-apps://apps.apple.com/app/id1';
                } else { // 下载apk文件
                    this.appdownloadVisible = true;
                }
            }
        },
        moreClick(item) {
            this.$router.push(item.verTudo.replace("/#",""));
        },
        checkActivity(){
            Lucky().then(res => {
                if(res.code == 200 && res.data){
                    this.cashVisible = true;
                    this.cashwheelid = res.data.activityId;
                    this.cashwheelrule = res.data.rules;
                    this.cashStartTime = parseInt(res.data.displayStartTime);
                    this.cashEndTime = parseInt(res.data.displayEndTime);
                }
            })
        },
        checkAdv(){
            if(localStorage.getItem("readPopover")){
                this.addVisible = false;
                this.noticeVisible = false;
            }else{
                this.noticeVisible = true;
                this.initAdvInfo();
            }
        }
    },
    mounted() {
        window.addEventListener('beforeinstallprompt', (e) => {
            e.preventDefault();
            this.deferredPrompt = e;
        });
        EventBus.$on('downloadAPP', () => {
            this.addToHomeScreen();
        });
        this.$refs.fatherScroll.addEventListener('scroll', this.checkScroll);
    },
    activated(){
        this.checkActivity(); // 检查转盘活动
        EventBus.$emit("loadBalance")
        EventBus.$emit("reMountLogo")
        EventBus.$emit("updateBanner")
        if(localStorage.getItem("finishModal")){
            this.checkAdv()
        }
        setTimeout(() => { 
            this.$message.closeAll();   
        },2000)
        this.checkScroll();

        if(getHashParam("wheel") == 'open'){ // 打开弹窗
            // 移除哈希路径中的 wheel=open 参数
            const hash = window.location.hash;
            const newHash = hash.replace(/([?&])wheel=open(&|$)/, (match, p1, p2) => {
                // 判断是否有其他参数，如果有则保留 ? 或 &，否则去掉
                return p1 === '?' && p2 ? p1 : '';
            }).replace(/[?&]$/, ''); // 移除末尾多余的 ? 或 &
            // 更新哈希路径
            window.history.replaceState(null, '', window.location.pathname + newHash);
            this.$router.push("/home")
            this.$nextTick(() => {
                setTimeout(() => {
                    this.toCashWheel();
                },200);
            })
        }
    },
    beforeDestroy() {
        clearInterval(this.intervalId);
        this.$refs.fatherScroll.removeEventListener('scroll', this.checkScroll);
    },
    watch:{
        $route(){
            if(getHashParam("wheel") == 'open'){ // 打开弹窗
                // 移除哈希路径中的 wheel=open 参数
                const hash = window.location.hash;
                const newHash = hash.replace(/([?&])wheel=open(&|$)/, (match, p1, p2) => {
                    // 判断是否有其他参数，如果有则保留 ? 或 &，否则去掉
                    return p1 === '?' && p2 ? p1 : '';
                }).replace(/[?&]$/, ''); // 移除末尾多余的 ? 或 &
                // 更新哈希路径
                window.history.replaceState(null, '', window.location.pathname + newHash);
                this.$router.push("/home")
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.toCashWheel();
                    },500);
                })
            }
        }
    },
}
</script>

<style scoped>

.activityNotice {
    position: absolute;
    width: 25rem;
    height: 4rem;
    background: linear-gradient(to bottom, var(--notice1), var(--notice2));
    z-index: 100;
    left: 50%;
    margin-left: -12.5rem;
    border-bottom-left-radius: 2rem;
    border-bottom-right-radius: 2rem;
    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 1.7rem;
    font-weight: bold;
}

.closeButton path {
    fill: rgba(255, 255, 255, .8);
}

.closeButton svg {
    height: 4rem;
    width: 4rem;
}

.closeButton {
    margin-top: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.swiper-button-next {
    background: rgba(0, 0, 0, 0.4);
    right: 0%;
    border-top-left-radius: 2rem;
    border-bottom-left-radius: 2rem;
    box-sizing: border-box;
    padding-left: .8rem;
}

.swiper-button-next::after {
    color: #fff;
    font-size: 1.7rem;
}

.swiper-button-prev::after {
    color: #fff;
    font-size: 1.7rem;
}

.swiper-button-prev {
    background: rgba(0, 0, 0, 0.4);
    left: 0%;
    border-top-right-radius: 2rem;
    border-bottom-right-radius: 2rem;
    box-sizing: border-box;
    padding-right: .8rem;
}

.swiper-slide {
    border-radius: 1rem;
    overflow: hidden;
    width: 100%;
    display: flex;
    align-items: center;
    height: 100% !important; /* 设置轮播项高度 */
}

.swiper-slide img {
    width: 100%;
    height: 28rem;
}

.banner-container {
    width: 100%;
    height: 28rem;
    overflow: hidden;
    border-radius: 2rem;
    position: relative;
}

.adverBox > div {
    width: 100%;
}

.adverBox {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border-radius: 1rem;
    align-items: center;
    width: 100%;
}

.noticeText > span {
    margin-bottom: 2.5rem;
}

.noticeText {
    display: flex;
    flex-direction: column;
    font-size: 1.5rem;
    font-weight: bold;
    color: var(--noticered);
    margin-top: 2.5rem;
    position:relative;
    z-index:2;
    height:100%;
    margin-bottom: 1.5rem;
    flex:1;
    overflow-x:hidden;
    overflow-y:scroll;
    scrollbar-width: none;
}

.noticeTitle path {
    fill:var(--basic)
}

.noticeTitle > svg {
    width: 3rem;
    height: 3rem;
}

.noticeTitle > span {
    color: var(--basic);
    font-size: 3.5rem;
    font-weight: bold;
    align-self: flex-end;
    text-shadow: 2px 2px 0 var(--shadow), 2px -2px 0 var(--shadow), -2px -2px 0 var(--shadow), -2px 2px 0 var(--shadow), 2px 3px 0 var(--shadow), 2px -3px 0 var(--shadow), -2px -3px 0 var(--shadow), -2px 3px 0 var(--shadow), 2px 2px 0 var(--shadow), 2px -2px 0 var(--shadow), -2px -2px 0 var(--shadow), -2px 2px 0 var(--shadow), 2px 1px 0 var(--shadow), 2px -1px 0 var(--shadow), -2px -1px 0 var(--shadow), -2px 1px 0 var(--shadow), 2px 0px 0 var(--shadow), 2px 0px 0 var(--shadow), -2px 0px 0 var(--shadow), -2px 0px 0 var(--shadow), 3px 2px 0 var(--shadow), 3px -2px 0 var(--shadow), -3px -2px 0 var(--shadow), -3px 2px 0 var(--shadow), 3px 3px 0 var(--shadow), 3px -3px 0 var(--shadow), -3px -3px 0 var(--shadow), -3px 3px 0 var(--shadow), 3px 2px 0 var(--shadow), 3px -2px 0 var(--shadow), -3px -2px 0 var(--shadow), -3px 2px 0 var(--shadow), 3px 1px 0 var(--shadow), 3px -1px 0 var(--shadow), -3px -1px 0 var(--shadow), -3px 1px 0 var(--shadow), 3px 0px 0 var(--shadow), 3px 0px 0 var(--shadow), -3px 0px 0 var(--shadow), -3px 0px 0 var(--shadow), 2px 2px 0 var(--shadow), 2px -2px 0 var(--shadow), -2px -2px 0 var(--shadow), -2px 2px 0 var(--shadow), 2px 3px 0 var(--shadow), 2px -3px 0 var(--shadow), -2px -3px 0 var(--shadow), -2px 3px 0 var(--shadow), 2px 2px 0 var(--shadow), 2px -2px 0 var(--shadow), -2px -2px 0 var(--shadow), -2px 2px 0 var(--shadow), 2px 1px 0 var(--shadow), 2px -1px 0 var(--shadow), -2px -1px 0 var(--shadow), -2px 1px 0 var(--shadow), 2px 0px 0 var(--shadow), 2px 0px 0 var(--shadow), -2px 0px 0 var(--shadow), -2px 0px 0 var(--shadow), 1px 2px 0 var(--shadow), 1px -2px 0 var(--shadow), -1px -2px 0 var(--shadow), -1px 2px 0 var(--shadow), 1px 3px 0 var(--shadow), 1px -3px 0 var(--shadow), -1px -3px 0 var(--shadow), -1px 3px 0 var(--shadow), 1px 2px 0 var(--shadow), 1px -2px 0 var(--shadow), -1px -2px 0 var(--shadow), -1px 2px 0 var(--shadow), 1px 1px 0 var(--shadow), 1px -1px 0 var(--shadow), -1px -1px 0 var(--shadow), -1px 1px 0 var(--shadow), 1px 0px 0 var(--shadow), 1px 0px 0 var(--shadow), -1px 0px 0 var(--shadow), -1px 0px 0 var(--shadow), 0px 2px 0 var(--shadow), 0px -2px 0 var(--shadow), 0px -2px 0 var(--shadow), 0px 2px 0 var(--shadow), 0px 3px 0 var(--shadow), 0px -3px 0 var(--shadow), 0px -3px 0 var(--shadow), 0px 3px 0 var(--shadow), 0px 2px 0 var(--shadow), 0px -2px 0 var(--shadow), 0px -2px 0 var(--shadow), 0px 2px 0 var(--shadow), 0px 1px 0 var(--shadow), 0px -1px 0 var(--shadow), 0px -1px 0 var(--shadow), 0px 1px 0 var(--shadow), 0px 0px 0 var(--shadow), 0px 0px 0 var(--shadow), 0px 0px 0 var(--shadow), 0px 0px 0 var(--shadow), 0 0 0 var(--shadow);
}

.noticeTitle {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding-left: 1rem;
    position:relative;
    z-index:2;
}

.noticeBox {
    position:relative;
    height: fit-content;
    width: 90%;
    background-size:100% 100%;
    /* background-color:var(--modalgdient); */
    background-repeat: no-repeat;
    box-sizing: border-box;
    padding: 1rem 1.5rem 1rem 1.5rem;
    height:42rem;
    border-radius:2rem;
    display:flex;
    flex-direction: column;
}

.noticeOutBox{
    display:flex;
    flex-direction: column;
    align-items:center;
}

.noticeOutBox > svg {
    width:4rem;
    height:4rem;
    margin-top:2rem;
}

.noticeOutBox path {
    fill:rgba(255, 255, 255, .8);
}

@keyframes scaleAnimation {
    0% {
        transform: scale(1); /* 开始时正常大小 */
    }
    100% {
        transform: scale(1.1); /* 结束时放大到1.2倍 */
    }
}

.addToScreenPover > img {
    height: 2rem;
    width: 2rem;
    margin-left: 1rem;
}

.addToScreenPover {
    animation: scaleAnimation 1s infinite alternate;
    position: absolute;
    z-index: 30;
    width: 6rem;
    height: 2.5rem;
    background: linear-gradient(to bottom, var(--error), var(--error));
    border-radius: 2rem;
    color: #fff;
    font-size: 1.3rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: .5rem;
    padding-left: 1.2rem;
    right: 1rem;
    top: -1.5rem;
}

.addToScreen {
    width: 20rem;
    height: 4rem;
    z-index: 23;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--subbackground);
    color: var(--warning);
    position: fixed;
    right: calc(50% - 10rem);
    bottom: 10rem;
    font-size: 1.5rem;
    font-weight: bold;
    border-radius: 1rem;
    box-shadow:0px 0px 1rem var(--background);
}
</style>

<style scoped>

.previous-list,
.next-list {
  cursor: pointer;
}

.next-list{
    width:2rem;
    height:calc(100% - 2.5rem);
    position:absolute;
    right:2rem;
    top:2rem;
    background:#000;
    z-index:10;
    background: linear-gradient(to right, transparent, var(--gdient1));
    opacity: 0.5;
    display:flex;
    align-items: center;
    justify-content: center;
    border-radius:1rem;
}
.previous-list{
    width:2rem;
    height:calc(100% - 2.5rem);
    position:absolute;
    left:2rem;
    top:2rem;
    background:#000;
    z-index:10;
    background: linear-gradient(to left, transparent, var(--gdient1));
    opacity: 0.5;
    display:flex;
    align-items: center;
    justify-content: center;
    border-radius:1rem;
}
.list-button{
    height:2rem;
    width:2rem;
    background:var(--primary);
    border-radius:50%;
    display:flex;
    align-items: center;
    justify-content: center;
}
.list-button > svg {
    width:1.5rem;
    height:1.5rem;
}
.list-button path {
    fill:var(--subfont);
}

.class-list-container{
    position: relative;
    width: calc(100% + 4rem);
    margin-left:-2rem;
    overflow: hidden; /* 限制滚动内容超出边界 */
    height: 11rem;
    box-sizing:border-box;
    padding:0 2rem;
}

.class-list {
    padding-top:2rem;
    position: relative;
    height:100%;
    width: 100%;
    white-space: nowrap;
    overflow-y:hidden;
    overflow-x: auto;
    box-sizing:border-box;
    padding-bottom:0.5rem;
}

/*滚动条样式*/
.class-list::-webkit-scrollbar { /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 4px;
    border-radius:0.5rem;
    overflow:hidden;
}

.class-list::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
    background: var(--gdient2);
    opacity:0.5;
    border-radius:0.5rem;
    overflow:hidden;
}

.class-list::-webkit-scrollbar-track { /*滚动条里面外层轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
    border-radius: 0;
    background: var(--primary);
    opacity:0.2;
    border-radius:0.5rem;
    overflow:hidden;
}

.recent-list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 1rem;
}

.confirmButton {
    color: #fff;
    width: 12rem;
    background: var(--success);
    height: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.5rem;
    border-radius: 1rem;
    cursor: pointer;
}

.cancelButton {
    color: #fff;
    width: 12rem;
    background: var(--error);
    height: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.5rem;
    border-radius: 1rem;
    cursor: pointer;
}

.confirmOption {
    display: flex;
    justify-content: space-around;
    margin-top: 2rem;
    box-sizing: border-box;
    padding: 0 3rem;
}

.confirmDes {
    color: var(--mainfont);
    font-size: 1.7rem;
    font-weight: bold;
}

.searchBox input::placeholder {
    color: var(--subfont);
}

.searchBox input {
    color: #fff;
    font-size: 2rem;
    font-weight: bold;
    margin-left: 1.5rem;
    background: none;
    outline: none;
    border: none;
}

.searchBox svg {
    width: 3rem;
    height: 3rem;
}

.searchBox path {
    fill:var(--subfont);
}

.searchBox img {
    height: 2.5rem;
}

.searchBox {
    border: 1px solid var(--subfont);
    box-sizing: border-box;
    height: 5rem;
    border-radius: 1rem;
    align-items: center;
    display: flex;
    padding: 0 2rem;
    margin-bottom:1rem;
}

.game-list {
    display: flex;
    flex-wrap: wrap;
}

.game-title-right {
    cursor: pointer;
    background: var(--primary);
    color: var(--subfont);
    box-sizing: border-box;
    padding: .8rem 1rem;
    font-size: 1.5rem;
    border-radius: .5rem;
    font-weight:bold;
}

.game-title-left {
    display: flex;
    align-items: center;
}

.game-title-left span {
    margin-left:1rem;
    color: var(--mainfont);
    font-weight:bold;
    font-size: 1.8rem;
}

.game-title-left img {
    height: 3rem;
}

.game-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom:
}
.game-box {
    margin-top: 2rem;
}

.box {
    background: var(--background);
    box-sizing: border-box;
    padding-top: 8rem;
    padding-bottom: 8rem;
    box-sizing: border-box;
    padding: 2rem 2rem;
    overflow:hidden;
    /* overflow-y:scroll;
    height:calc(100vh - 16rem); */
    /* height:20rem; */
}

.swiper-slide {
    width: 100%;
    display: flex;
    align-items: center;
    height: 100% !important; /* 设置轮播项高度 */
}

.swiper-slide img {
    width: 100%;
    height: 28rem;
}

.banner-container {
    width: 100%;
    height: 26rem;
    overflow: hidden;
    border-radius: 2rem;
    position: relative;
}

</style>
